(function ADA_UnifiedPatches() {
  'use strict';
  if (window.__adaUnifiedPatchesInit) return;
  window.__adaUnifiedPatchesInit = true;

  function setAttr(el, name, value) {
    if (!el) return;
    var cur = el.getAttribute(name);
    if (String(cur) !== String(value)) el.setAttribute(name, value);
  }

  function removeAttr(el, name) {
    if (!el) return;
    if (el.hasAttribute(name)) el.removeAttribute(name);
  }

  function setAttrs(el, attrs) {
    if (!el) return;
    for (var k in attrs) {
      if (!Object.prototype.hasOwnProperty.call(attrs, k)) continue;
      var v = attrs[k];
      if (v === undefined || v === null) continue;
      setAttr(el, k, v);
    }
  }

  function setStyle(el, name, value) {
    if (!el || !el.style) return;
    if (el.style[name] !== value) el.style[name] = value;
  }

  function onEnterSpace(el, handler) {
    if (!el || el.__adaKbBound) return;
    el.__adaKbBound = true;
    el.addEventListener('keydown', function (e) {
      var key = e.key || e.code;
      if (key === 'Enter' || key === ' ' || key === 'Spacebar') {
        e.preventDefault();
        handler();
      }
    });
  }

  function safeClick(el) {
    try {
      el && el.click && el.click();
    } catch (e) {}
  }

  /*
   * RETIRADO - patchAccessWidget()
   *
   * PM-WAC-03 (WCAG 2.5.3 / F96): el skip link de accessiBe muestra la etiqueta
   * visual "Skip to Content ENTER" y exponia el nombre accesible
   * "Skip to Content". Esta funcion era la causa directa del desajuste: ponia
   * aria-hidden="true" sobre el <span> del ENTER y despues fijaba el aria-label
   * solo con el texto restante.
   *
   * El resto de lo que hacia (retirar aria-hidden de <access-widget-ui>,
   * dimensionar su disparador a 44px, nombrarlo) es maquillaje sobre marcado
   * de un tercero. Los defectos del overlay (WAC-A11Y-037/038/039/041,
   * PM-WAC-02, PM-WAC-03) quedan escalados a accessiBe: ver el informe.
   */

  function patchCookieConsent() {
    var root = document.getElementById('cb-cookie_consent');
    if (!root) return;

    root.querySelectorAll('.cb-cookie_consent-container-close_box').forEach(function (closeBox) {
      // WAC-A11Y-009 / WAC-A11Y-033 - al convertir el cierre en role="button"
      // pasa a evaluarse como objetivo tactil y aparece la violacion
      // `target-size`, que no existe si se bloquea este script. Se mantiene el
      // rol porque sin el no hay forma de cerrar el banner con el teclado, pero
      // se garantizan 24x24 px reales y separacion:
      //  - `flexShrink: 0` evita que un contenedor flex lo comprima por debajo
      //    del minimo pese al min-width/min-height.
      //  - `margin` aporta la separacion que exige WCAG 2.5.8.
      setAttrs(closeBox, { role: 'button', tabindex: '0', 'aria-label': 'Close cookie consent' });
      setStyle(closeBox, 'minWidth', '44px');
      setStyle(closeBox, 'minHeight', '44px');
      setStyle(closeBox, 'padding', '10px');
      setStyle(closeBox, 'margin', '4px');
      setStyle(closeBox, 'flexShrink', '0');
      setStyle(closeBox, 'display', 'inline-flex');
      setStyle(closeBox, 'alignItems', 'center');
      setStyle(closeBox, 'justifyContent', 'center');
      setStyle(closeBox, 'boxSizing', 'border-box');
      setStyle(closeBox, 'cursor', 'pointer');
      setStyle(closeBox, 'touchAction', 'manipulation');

      onEnterSpace(closeBox, function () {
        safeClick(closeBox);
        var icon = closeBox.querySelector('#CloseIcon') || closeBox.querySelector('svg');
        if (icon) safeClick(icon);
      });

      var closeIcon = closeBox.querySelector('#CloseIcon') || closeBox.querySelector('svg');
      if (closeIcon) {
        setAttrs(closeIcon, { role: 'presentation', 'aria-hidden': 'true' });
        if (closeIcon.getAttribute('aria-label') === '') removeAttr(closeIcon, 'aria-label');
      }
    });

    root.querySelectorAll('.cb-cookie_consent-container-text_container > svg').forEach(function (svg) {
      setAttrs(svg, { role: 'presentation', 'aria-hidden': 'true' });
      if (svg.getAttribute('aria-label') === '') removeAttr(svg, 'aria-label');
    });
  }

  /*
   * RETIRADO - patchShopifyStructure()
   *
   * PM-WAC-08 (ARIA 3.2 / 4.2): asignaba role="contentinfo" a `body > footer`.
   * <footer> en el nivel superior ya expone contentinfo de forma implicita, asi
   * que el rol era redundante (4 instancias). Ver tambien WAC-A11Y-042/043/044:
   * el contentinfo duplicado y anidado venia del <footer class="mf-footer"
   * role="contentinfo"> del cajon de filtros, corregido en su Liquid.
   */

  function patchAcsbRemoveTabindex() {
    document.querySelectorAll('[data-test="bigWhiteCursor"][role="switch"][tabindex], [data-test="bigBlackCursor"][role="switch"][tabindex]').forEach(function (el) {
      removeAttr(el, 'tabindex');
    });
  }

  /*
   * RETIRADO - patchCarouselRegions()
   *
   * WAC-A11Y-051 (landmark-unique): asignaba role="region" aria-label="carousel"
   * a DOS elementos distintos de la ficha de producto, creando dos landmarks con
   * el mismo nombre. La prueba de resiliencia confirmo que la violacion
   * desaparecia al bloquear ada.js.
   *
   * La intencion se ha migrado a snippets/product__product-images.liquid con
   * nombres distintos ("Product images" / "Product image thumbnails").
   */


  function getNormalizedText(text) {
    return (text || '').replace(/\s+/g, ' ').trim();
  }





  function isElementVisuallyHidden(el) {
    if (!el || !window.getComputedStyle) return false;

    var styles = window.getComputedStyle(el);
    if (styles.display === 'none' || styles.visibility === 'hidden') return true;
    if (el.getClientRects && el.getClientRects().length === 0) return true;

    return false;
  }


  function getVisibleLinkText(a) {
    if (!a) return '';

    var clone = a.cloneNode(true);
    clone.querySelectorAll('.sr-only, [aria-hidden="true"]').forEach(function (el) {
      el.remove();
    });

    return getNormalizedText(clone.textContent);
  }

  function hasMeaningfulLinkContent(a) {
    if (!a) return false;
    if (getVisibleLinkText(a)) return true;

    return !!a.querySelector('img, svg, picture, video, canvas, [role="img"]:not([aria-hidden="true"])');
  }

  function syncManagedLinkVisibility(a) {
    if (!a || !a.hasAttribute('ada-link-managed')) return;

    if (hasMeaningfulLinkContent(a)) {
      if (a.getAttribute('aria-label') === '') removeAttr(a, 'aria-label');
      removeAttr(a, 'aria-hidden');
      return;
    }

    setAttr(a, 'aria-hidden', 'true');
  }



  function patchEmptyManagedLinks() {
    [
      '#shopify-section-footer footer.main-footer .wrapper .row.top-row .col.col-md-3.col-xs-12 > a.flex.justify-center[ada-link-managed]',
      '#shopify-section-header header.main-header .main-header--wrapper.wrapper.relative .main-header--inner > a[ada-link-managed]',
      '#shopify-section-header header.main-header .main-header--wrapper.wrapper.relative .main-header--buttons.flex.absolute > a.main-header--button[ada-link-managed]'
    ].forEach(function (selector) {
      document.querySelectorAll(selector).forEach(function (link) {
        syncManagedLinkVisibility(link);
      });
    });
  }




  function patchHeaderMenuRoles() {
    var header = document.querySelector('#shopify-section-header');
    if (!header) return;

    // El selector filtraba por [aria-label="main-menu"]. Ese valor se ha
    // renombrado a "Main navigation" (WAC-A11Y-056), asi que se filtra solo por
    // clase para que el parche siga aplicandose.
    header.querySelectorAll('nav.main-menu--container').forEach(function (nav) {
      var menuList = nav.querySelector('.main-menu');
      removeAttr(nav, 'role');

      if (!menuList || isElementVisuallyHidden(menuList)) {
        setAttr(nav, 'aria-hidden', 'true');
        return;
      }

      removeAttr(nav, 'aria-hidden');
    });

    header.querySelectorAll('nav.main-menu--container .main-menu[role], nav.main-menu--container .sub-menu[role], nav.main-menu--container .menu-item[role]').forEach(function (el) {
      removeAttr(el, 'role');
    });

    header.querySelectorAll('nav.main-menu--container .main-menu[aria-label], nav.main-menu--container .sub-menu[aria-label]').forEach(function (el) {
      removeAttr(el, 'aria-label');
    });

    // WAC-A11Y-001 / WAC-A11Y-018 - este parche retiraba `aria-haspopup` y
    // `aria-expanded` de los disparadores de submenu, que es exactamente lo que
    // el componente de menu de application.js emite y mantiene sincronizado en
    // _addChildAria() y _handleMutation(). El resultado era que los
    // disparadores no exponian su estado a las tecnologias de apoyo.
    // Se conserva unicamente la retirada de `role="menuitem"`: el tema no
    // implementa el patron menubar completo (no hay gestion de foco por
    // flechas conforme a APG en todos los niveles) y anunciarlo como tal es
    // peor que dejar la navegacion como lista de enlaces.
    header.querySelectorAll('nav.main-menu--container .main-menu a[role="menuitem"]').forEach(function (a) {
      removeAttr(a, 'role');
    });

    header.querySelectorAll('nav.main-menu--container .main-menu a[ada-link-managed="1"][role]').forEach(function (a) {
      removeAttr(a, 'role');
    });
  }

  function patchFrcpPopup() {
    document.querySelectorAll('.frcp-login.frcp-popup').forEach(function (popup) {
      setAttrs(popup, { role: 'dialog', 'aria-modal': 'true' });

      // Sustituye a patchFrcpTitleHeadings(): en lugar de simular un
      // encabezado con role="heading" (rol redundante, PM-WAC-08), el titulo
      // pasa a ser el nombre accesible del dialogo.
      var title = popup.querySelector('.frcp-popup__header > .frcp-popup__title');
      if (title && getNormalizedText(title.textContent)) {
        if (!title.id) title.id = 'frcp-popup-title';
        setAttr(popup, 'aria-labelledby', title.id);
      }
    });

    document.querySelectorAll('.frcp-popup__close').forEach(function (el) {
      setAttrs(el, { role: 'button', tabindex: '0', 'aria-label': 'Close dialog' });
      onEnterSpace(el, function () {
        safeClick(el);
      });
    });

    document.querySelectorAll('.frcp-form__switch--registration, .frcp-form__switch--login').forEach(function (el) {
      setAttrs(el, { role: 'button', tabindex: '0' });
      onEnterSpace(el, function () {
        safeClick(el);
      });
    });
  }

  function patchFrcpWishlistButtons() {
    document.querySelectorAll('.frcp-wishlist-btn').forEach(function (el) {
      var tabindex = parseInt(el.getAttribute('tabindex'), 10);
      if (!isNaN(tabindex) && tabindex > 0) {
        setAttr(el, 'tabindex', '0');
      }

      if (el.getAttribute('role') === 'button' && el.tagName !== 'BUTTON' && el.tagName !== 'A') {
        onEnterSpace(el, function () {
          safeClick(el);
        });
      }

      setStyle(el, 'minWidth', '44px');
      setStyle(el, 'minHeight', '44px');
      setStyle(el, 'display', 'inline-flex');
      setStyle(el, 'alignItems', 'center');
      setStyle(el, 'justifyContent', 'center');
    });
  }

  function patchIframes() {
    document.querySelectorAll('iframe').forEach(function (el) {
      var title = getNormalizedText(el.getAttribute('title'));
      var label = getNormalizedText(el.getAttribute('aria-label'));

      if (title && label) {
        removeAttr(el, 'aria-label');
        return;
      }

      if (!title && !label) {
        setAttr(el, 'title', 'Embedded content');
      }
    });
  }

  function patchSs360DecorativeIcons() {
    document.querySelectorAll('#ss360-error-layer .ss360-error__icon > svg').forEach(function (svg) {
      setAttrs(svg, {
        'aria-hidden': 'true',
        role: 'presentation',
        focusable: 'false'
      });
    });
  }

  function patchSs360RegionLabels() {
    document.querySelectorAll('#ss360-layer > section.ss360-layer__content[aria-labelledby]').forEach(function (section) {
      var labelId = section.getAttribute('aria-labelledby');
      if (!labelId) return;

      var labelEl = document.getElementById(labelId);
      if (labelEl && getNormalizedText(labelEl.textContent) && !isElementVisuallyHidden(labelEl)) {
        return;
      }

      var fallbackHeading = section.querySelector('.ss360-layer__heading, .ss360-layer__title, h1, h2, h3, h4, h5, h6');
      if (fallbackHeading && getNormalizedText(fallbackHeading.textContent) && !isElementVisuallyHidden(fallbackHeading)) {
        fallbackHeading.id = labelId;
        removeAttr(section, 'aria-label');
        return;
      }

      removeAttr(section, 'aria-labelledby');
      setAttr(section, 'aria-label', 'Search results');
    });
  }


  function patchPatternSliderSlides() {
    // WAC-PERF-08 (forced-reflow-insight, 56 nodos en 21 plantillas) - la
    // version anterior alternaba lectura de geometria
    // (getBoundingClientRect, dentro de isElementVisibleWithinContainer) con
    // escritura de atributos en la misma vuelta del bucle. Cada escritura
    // invalida el layout, asi que la lectura de la diapositiva siguiente
    // obligaba al navegador a recalcularlo entero: un reflow por diapositiva.
    //
    // Ahora se hacen TODAS las lecturas primero y TODAS las escrituras despues.
    document.querySelectorAll('.pattern-slider--actual.slick-initialized').forEach(function (slider) {
      var list = slider.querySelector('.slick-list');
      if (!list) return;

      var slides = slider.querySelectorAll('.slick-slide');
      if (!slides.length) return;

      // --- Fase de lectura: ni una sola escritura aqui dentro. ---
      var containerRect = list.getBoundingClientRect();
      var measurements = [];
      slides.forEach(function (slide) {
        var rect = slide.getBoundingClientRect();
        var visibleWidth = Math.min(rect.right, containerRect.right) - Math.max(rect.left, containerRect.left);
        var visibleHeight = Math.min(rect.bottom, containerRect.bottom) - Math.max(rect.top, containerRect.top);
        measurements.push({
          slide: slide,
          isVisible: visibleWidth > 1 && visibleHeight > 1
        });
      });

      // --- Fase de escritura: ni una sola lectura de geometria aqui dentro. ---
      measurements.forEach(function (entry) {
        var slide = entry.slide;

        if (entry.isVisible) {
          removeAttr(slide, 'aria-hidden');
          removeAttr(slide, 'tabindex');
        } else {
          setAttr(slide, 'aria-hidden', 'true');
          setAttr(slide, 'tabindex', '-1');
        }

        slide.querySelectorAll('a, button, input, select, textarea').forEach(function (control) {
          if (entry.isVisible) {
            removeAttr(control, 'tabindex');
          } else {
            setAttr(control, 'tabindex', '-1');
          }
        });
      });
    });
  }

  function patchAcsbScreenReaderToggle() {
    var isScreenReaderMode =
      document.documentElement.classList.contains('acsb-screen-reader') ||
      document.body.classList.contains('acsb-screen-reader') ||
      document.documentElement.hasAttribute('data-acsb-screen-reader') ||
      document.body.hasAttribute('data-acsb-screen-reader');

    document.querySelectorAll(
      '[data-acsb-action="screen-reader"], [data-acsb-feature="screen-reader"], [data-action-name="readableFont"][role="switch"], access-widget-ui [role="switch"][aria-labelledby*="screen"], access-widget-ui [data-action-name*="screenReader"]'
    ).forEach(function (el) {
      setAttr(el, 'aria-pressed', isScreenReaderMode ? 'true' : 'false');
    });
  }

  function patchCookieBannerOrder() {
    var banner =
      document.getElementById('cb-cookie_consent') ||
      document.querySelector('.cb-cookie_consent-container, [class*="cookie"][class*="consent"]:not([class*="policy"])');
    if (!banner) return;

    var container = banner.matches('.cb-cookie_consent-container') ? banner : banner.querySelector('.cb-cookie_consent-container') || banner;
    if (!container || container.__adaCookieOrdered) return;

    var landmark = container.getAttribute('role') === 'region' || container.getAttribute('role') === 'complementary';
    if (!landmark) {
      setAttrs(container, { role: 'region', 'aria-label': 'Cookie consent' });
    }
    container.__adaCookieOrdered = true;
  }



  /*
   * RETIRADO - patchPronunciation()
   *
   * PM-WAC-01 (ARIA 5.2.8.6, Nivel A Critico): ponia aria-label sobre <p>,
   * <li> y <span>, elementos cuyo rol implicito prohibe el nombrado. Ejemplos
   * detectados en produccion:
   *   <p aria-label='Monday through Thursday: 10am-8pm'>
   *   <p aria-label='Friday through Sunday: 10am-5pm'>
   *   <span aria-label='Visit us'>
   * No mejora la pronunciacion (los lectores de pantalla no usan aria-label
   * para eso) y generaba errores de Nivel A en varias plantillas.
   *
   * Si se quiere que "Mon-Thur" se lea mejor, hay que cambiar el TEXTO del
   * contenido, no anadir ARIA. Ese texto vive en los ajustes del pie y en el
   * aviso del sitio, editables desde el admin: queda anotado en el informe
   * como tarea fuera de Git.
   */

  function patchHomepageBlankSpans() {
    document.querySelectorAll('.main-header > span.sr-only[role="img"], .style-settings-container > span.sr-only[role="img"]').forEach(function (span) {
      if (!getNormalizedText(span.textContent)) {
        setAttr(span, 'aria-hidden', 'true');
        removeAttr(span, 'role');
      }
    });
  }

  /*
   * RETIRADO - patchFrcpTitleHeadings()
   *
   * PM-WAC-08 (ARIA 3.2): anadia role="heading" + aria-level a elementos que en
   * varios casos ya eran encabezados nativos, produciendo roles redundantes
   * (5 instancias contadas por PowerMapper).
   *
   * La intencion real era que el titulo del popup de Froonze se anunciara. Eso
   * se resuelve mejor en patchFrcpPopup(), nombrando el dialogo con
   * aria-labelledby en lugar de simular un encabezado. El popup lo inyecta la
   * app, asi que no puede emitirse desde Liquid.
   */

  function fixSubmitButtons() {
    document.querySelectorAll('#frcp_customer_login button, #frcp_create_customer button').forEach(function (btn) {
      if (!btn.hasAttribute('type')) {
        btn.setAttribute('type', 'submit');
      }
    });
  }

  function patchAll() {
    // BLOQUE 7 - retiradas: patchAccessWidget(), patchShopifyStructure(),
    // patchCarouselRegions(), patchPronunciation() y patchFrcpTitleHeadings().
    // Cada una esta documentada en el lugar que ocupaba.
    patchAcsbScreenReaderToggle();
    patchCookieConsent();
    patchCookieBannerOrder();
    patchAcsbRemoveTabindex();
    patchSs360DecorativeIcons();
    patchSs360RegionLabels();
    patchPatternSliderSlides();
    patchEmptyManagedLinks();
    patchHeaderMenuRoles();
    patchFrcpPopup();
    patchFrcpWishlistButtons();
    patchIframes();
    patchHomepageBlankSpans();
    fixSubmitButtons();
  }

  // Las mutaciones llegan a rafagas (apps de terceros, slick, accessiBe): se
  // agrupan y patchAll() se aplica como maximo cada PATCH_INTERVAL ms en lugar
  // de en cada frame, que llegaba a ~1 s de CPU en movil durante la carga.
  var PATCH_INTERVAL = 250;
  var patchScheduled = false;
  var observerRunning = false;
  var lastPatchAt = 0;
  var resizeTimer = null;

  function schedulePatch() {
    if (patchScheduled) return;
    patchScheduled = true;

    var wait = Math.max(0, PATCH_INTERVAL - (Date.now() - lastPatchAt));
    window.setTimeout(function () {
      patchScheduled = false;
      if (observerRunning) return;
      observerRunning = true;
      lastPatchAt = Date.now();
      try {
        patchAll();
      } finally {
        observerRunning = false;
      }
    }, wait);
  }

  function scheduleSliderPatch() {
    if (resizeTimer) clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () {
      patchPatternSliderSlides();
    }, 150);
  }

  function run() {
    patchAll();

    window.addEventListener('load', function () {
      schedulePatch();
      patchPatternSliderSlides();
    });

    window.addEventListener('resize', scheduleSliderPatch);

    var mo = new MutationObserver(function (muts) {
      if (muts.length) schedulePatch();
    });

    mo.observe(document.documentElement, {
      childList: true,
      subtree: true,
      characterData: true,
      attributes: true,
      attributeFilter: ['class', 'href', 'open', 'hidden', 'tabindex', 'data-acsb-screen-reader', 'data-testid', 'data-action-name', 'data-acsb-action', 'data-acsb-feature']
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run, { once: true });
  } else {
    run();
  }
})();